import React from 'react';
import SolutionInstallmentExaminationInfoContainer from 'containers/SolutionInstallmentExaminationInfoContainer/SolutionInstallmentExaminationInfoContainer';

export default function SolutionInstallmentExaminationInfoPage() {
    return (
        <SolutionInstallmentExaminationInfoContainer />
    )
}
